import { i18n } from '@fs/zion-locale'
import { useFlagsContext } from '../providers'
import { expoHallConfig, FLAGS } from '../config'

export default function useShowExpoHall() {
  const { [FLAGS.EXPOHALL]: expoHallFlag } = useFlagsContext()
  const userLocale = i18n.language
  return expoHallFlag.isOn && expoHallConfig.locales.includes(userLocale)
}
